import { Box, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

import { capitalizeFirst } from "@nens/shared-utils";

import { ReportPage } from "./report-page";

const SOURCE_KEYS = ["kaart", "bron", "scenario", "bronjaar"] as const;

type Source = {
  [key in (typeof SOURCE_KEYS)[number]]: string;
};

const SOURCES: Source[] = [
  {
    kaart: "Hoogtekaart",
    bron: "Algemeen Hoogtekaart Nederland 4 (AHN4) **",
    scenario: "-",
    bronjaar: "2021-2022",
  },
  {
    kaart: "Bodemkaart",
    bron: "Basisregistratie Ondergrond (BRO) *",
    scenario: "-",
    bronjaar: "2025",
  },
  {
    kaart: "Landgebruikskaart",
    bron: "Combinatie van Basisregistratie Adressen en Gebouwen (BAG), Basisregistratie Grootschalige Topografie (BGT), Basisregistratie Personen (BRP), TOP10NL *",
    scenario: "-",
    bronjaar: "2026",
  },
  {
    kaart: "Max. waterdiepte T100 bui",
    bron: "Rana Hydrodynamic Computational Core simulatie",
    scenario: "2050-WH***",
    bronjaar: "Real time",
  },
  {
    kaart: "Gem. Hoogste GWS (GHG)",
    bron: "Nationaal Watermodel (NWM) + BOFEK2012 + AHN3",
    scenario: "2050-WH",
    bronjaar: "2017",
  },
  {
    kaart: "Overstromingsdiepte T1000",
    bron: "KEA Overstromingsdiepte – Kleine kans (T1000)",
    scenario: "Huidig****",
    bronjaar: "2021****",
  },
  {
    kaart: "Overstromingskans plaatsgbnd.",
    bron: "KEA Plaatsgebonden overstromingskans >20 cm diepte",
    scenario: "Huidig****",
    bronjaar: "2021****",
  },
  {
    kaart: "Schaduwkaart",
    bron: "Combinatie zonnestand + AHN + bomenkaart (N & S)",
    scenario: "-",
    bronjaar: "2022",
  },
  {
    kaart: "Gevoelstemperatuur",
    bron: "Methode WUR (N & S)",
    scenario: "2050-Hd",
    bronjaar: "2023",
  },
  {
    kaart: "Verwachte bodemdaling",
    bron: "KEA Bodemdaling 2100 (peilindexatie)",
    scenario: "2100-WH",
    bronjaar: "2017",
  },
  {
    kaart: "Gem. Laagste GWS (GLG)",
    bron: "Nationaal Watermodel (NWM) + BOFEK2012 + AHN3",
    scenario: "2050-WH",
    bronjaar: "2017",
  },
  {
    kaart: "Natuurbrandgevoeligheid",
    bron: "KEA Natuurbrandgevoeligheid 2050",
    scenario: "2050-WH",
    bronjaar: "2021",
  },
  {
    kaart: "Stikstofgevoeligheid",
    bron: "Afstand op basis van Natura2000 gebieden",
    scenario: "-",
    bronjaar: "2026",
  },
  {
    kaart: "Soortendiversiteit",
    bron: "Nationale Databank Flora en Fauna (NDFF), door BIJ12",
    scenario: "-",
    bronjaar: "2017",
  },
  {
    kaart: "Beschermde soorten",
    bron: "Beschermde SoortenIndicator (BeSI), door BIJ12",
    scenario: "-",
    bronjaar: "2025",
  },
];

const FOOTNOTES = [
  "* Deze kaart is de basis, bewerkingen gedaan door Nelen & Schuurmans zoals interpolatie van no-data waarden.",
  "** Indien landelijk beschikbaar (2025-2027) kan deze geüpdatet worden naar AHN6.",
  "*** KNMI scenario 2050-WH ('upper scenario') uit 2014, waar T100 70 mm neerslag in één uur betekent. De nieuwe KNMI 2023 projectie geeft -door afgenomen onzekerheid- 60 mm in één uur als T100 bui. Voor de herleidbaarheid en robuustheid wordt alsnog 70 mm in één uur geadviseerd. In neerslagstatistiek op basis van KNMI-scenario's uit 2023 zou dit klimaatscenario 2100-H betekenen (71 mm in één uur).",
  "**** Binnenkort komen de nieuwe beelden uit 2025 beschikbaar, dit kan geüpdatet worden. Wellicht ook met klimaatscenario's inbegrepen.",
];

export const ReportPageSources = () => {
  return (
    <ReportPage>
      <Text fontWeight="bold" fontSize="sm">
        Tabel 1. Bronnen zoals gebruikt in Q1 2026 voor de klimaatscan.
      </Text>

      <TableContainer overflowX="unset" overflowY="unset">
        <Table size="sm" variant="report">
          <Thead>
            <Tr>
              {SOURCE_KEYS.map((key) => (
                <Th key={key}>{capitalizeFirst(key)}:</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {SOURCES.map((row) => (
              <Tr key={row.kaart}>
                {SOURCE_KEYS.map((key) => (
                  <Td key={key}>{row[key]}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>

      <Box fontSize="xs" color="gray.600">
        {FOOTNOTES.map((note) => (
          <Text key={note} mb={1}>
            {note}
          </Text>
        ))}
      </Box>
    </ReportPage>
  );
};
